/*
 * Global app preferences persisted in localStorage.
 * Currently: show/hide the "Legacy (archive)" sidebar group.
 * Extend by adding more keys — components read via useAppPref(key).
 */
import { useCallback, useEffect, useState } from "react";

const NS = "astat_prefs_v1";

const DEFAULTS = {
  showLegacyGroup: false, // hide legacy dispatch/bookings by default
};

function readAll() {
  try {
    const raw = localStorage.getItem(NS);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

function writeAll(prefs) {
  try {
    localStorage.setItem(NS, JSON.stringify(prefs));
    window.dispatchEvent(new CustomEvent("astat-prefs-changed", { detail: prefs }));
  } catch {
    /* ignore quota */
  }
}

export function useAppPref(key) {
  const [value, setValue] = useState(() => readAll()[key]);
  useEffect(() => {
    const onChange = (e) => {
      const p = e.detail || readAll();
      setValue(p[key]);
    };
    window.addEventListener("astat-prefs-changed", onChange);
    return () => window.removeEventListener("astat-prefs-changed", onChange);
  }, [key]);
  const set = useCallback((next) => {
    const prev = readAll();
    writeAll({ ...prev, [key]: next });
  }, [key]);
  return [value, set];
}

export function getAppPrefs() { return readAll(); }
export function setAppPref(key, val) { const p = readAll(); writeAll({ ...p, [key]: val }); }
